<div>
  <eds-title edsSpacing="sm" [size]="'h6'">{{
    "products.efficiency-analysis-table-header" | translate
  }}</eds-title>
  <table class="table">
    <thead class="table__thead">
      <tr class="table__tr">
        <th class="table__th table__th--middle">
          {{ "products.efficiency-analysis-statistic" | translate }}
          <eds-icon
            *ngIf="tooltips['products.efficiency-analysis-statistic-tooltip']"
            edsPadding
            edsPaddingLeft="xs"
            type="info"
            size="small"
            edsTooltip
            [analyticsName]="
              'products.efficiency-analysis-statistic' | translate
            "
            tooltipTheme="dark"
            [tooltipContent]="
              tooltips['products.efficiency-analysis-statistic-tooltip']
            "
          ></eds-icon>
        </th>
        <th class="table__th table__th--middle">
          {{
            "products.efficiency-analysis-above-the-benchmark-header"
              | translate
          }}
        </th>
        <th class="table__th table__th--middle">
          {{
            "products.efficiency-analysis-below-the-benchmark-header"
              | translate
          }}
        </th>
        <th class="table__th table__th--middle">
          {{ "products.efficiency-analysis-total-header" | translate }}
        </th>
        <th class="table__th table__th--middle">
          {{ "products.efficiency-analysis-hit-rate-header" | translate }}
        </th>
        <th class="table__th table__th--middle">
          {{ "products.efficiency-analysis-average-access-header" | translate }}
        </th>
      </tr>
    </thead>
    <tbody class="table__body">
      <tr class="table__tr" *ngFor="let rowData of state?.efficiencyAnalysis">
        <td class="table__td">
          {{ rowData?.statisticLabel | translate }}
          <eds-footnote
            [placement]="'Risk Efficiency Analysis:' + rowData.footnote"
          ></eds-footnote>
          <eds-icon
            *ngIf="rowData.tooltip"
            edsPadding
            edsPaddingLeft="xs"
            type="info"
            size="small"
            edsTooltip
            [analyticsName]="rowData.rmName"
            [tooltipContent]="rowData.tooltip"
          ></eds-icon>
        </td>
        <td class="table__td">
          {{ rowData?.aboveTheBenchmark | ftDashIfEmpty }}
        </td>
        <td class="table__td">
          {{ rowData?.belowTheBenchmark | ftDashIfEmpty }}
        </td>
        <td class="table__td">{{ rowData?.total | ftDashIfEmpty }}</td>
        <td class="table__td">
          {{ rowData?.hitRate | ftDashIfEmpty }}
        </td>
        <td class="table__td">
          {{ rowData?.averageExcess | ftDashIfEmpty }}
        </td>
      </tr>
    </tbody>
  </table>
</div>
